  class BundleCard extends HTMLElement {
    constructor() {
      super();
      this.state = {
        variant: this.getAttribute('variant'),
        variantId: this.getAttribute('variant-id'),
        variantImg: this.getAttribute('variant-img'),
        productHandle: this.getAttribute('product-handle'),
        isMain: this.getAttribute('is-main') === 'true',
      };
      this.mainImg = this.querySelector('.mu-bundle-img-container img');
    }
    connectedCallback() {
      // Listen for variant change on the main product
      if (this.state.isMain) {
        document.addEventListener('variant:change', (e) => {
          this.setState({
            variant: e.detail.variant.title,
            variantId: e.detail.variant.id,
            variantImg: e.detail.variant.featured_image?.src ?? e.detail.variant.img,
          });
        });
        document.addEventListener('homePageVariant:change', (e) => {
          this.setState({
            variant: e.detail.variant.title,
            variantId: e.detail.variant.id,
            variantImg: e.detail.variant.featured_image?.src ?? e.detail.variant.img,
          });
        });
      } else {
        this.addEventListener('featProdVariant:change', (e) => {
          this.setState({
            variant: e.detail.variant.title,
            variantId: e.detail.variant.id,
            variantImg: e.detail.variant.img,
          });
        });
      }
      // Event listener for variant badges
      this.addEventListener('click', (e) => {
        const button = e.target;
        if (button.tagName === 'BUTTON' && button.getAttribute('data-color')) {
          const variantTitle = button.getAttribute('title');
          const variantId = button.getAttribute('data-variant');
          const variantImg = button.getAttribute('data-img');

          this.markButtonAsSelected(button);

          const variant = {
            id: variantId,
            title: variantTitle,
            img: variantImg,
          };

          var updateEvent;
          if (this.state.isMain) {
            if (window.location.pathname === '/' || window.location.pathname === '') {
              updateEvent = new CustomEvent('homePageVariant:change', {
                detail: { variant },
                bubbles: true,
              });
            } else {
              updateEvent = new CustomEvent('variant:change', {
                detail: { variant },
                bubbles: true,
              });
            }
            this.dispatchEvent(updateEvent);
          } else {
            const event = new CustomEvent('featProdVariant:change', {
              detail: { variant },
              bubbles: true,
            });
            this.dispatchEvent(event);
          }
        }
      });
    }
    setState(newValue) {
      this.state = { ...this.state, ...newValue };
      this.update();
    }
    update() {
      // Mark button as selected
      const selectedButton = this.querySelector(`#mu-bundle-picker-${this.state.variantId}`);
      this.markButtonAsSelected(selectedButton);
      // Main Image
      this.setNewImage();
      // Set the URL
      this.setNewUrl();
    }
    markButtonAsSelected(selectedButton) {
      this.querySelectorAll('.mu-bundle button').forEach((button) => {
        button.classList.remove('is-active');
      });
      selectedButton.classList.add('is-active');
    }
    setNewImage() {
      this.mainImg.src = this.addWidthParam(this.state.variantImg, 1200);
      this.mainImg.removeAttribute('srcset');
    }
    setNewUrl() {
      this.querySelectorAll('.mu-bundle-link').forEach((link) => {
        link.href = `/products/${this.state.productHandle}?variant=${this.state.variantId}`;
      });
    }
    addWidthParam(url, width) {
      try {
        if (url.startsWith('//')) {
          url = 'https:' + url;
        } else if (url.startsWith('/')) {
          url = window.location.origin + url;
        }
        const imageUrl = new URL(url);
        imageUrl.searchParams.set('width', width);
        return imageUrl.toString();
      } catch (e) {
        console.error('Invalid image URL:', url, e);
        return url;
      }
    }
  }

  customElements.define('bundle-card', BundleCard);